import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';
import { QueryManagerService } from './queryManagerService';
import { lastValueFrom } from 'rxjs';
import {
  BackOfficeService,
  ServiceByEnveloppeCode,
  EnveloppeProduit,
  EnveloppeProduitFilterInput,
  Produit,
  ProduitFilterInput,
} from '../models/generated/graphql';

const enveloppesQuery = gql`
  query enveloppeProduits($where: EnveloppeProduitFilterInput) {
    enveloppeProduits(where: $where) {
      code
      libelle
      backOfficeService
    }
  }
`;

// Meme referentiel que ServiceByEnveloppeService cote serveur.
const enveloppeServiceMappingQuery = gql`
  query transactionEnveloppeServiceMapping {
    enveloppeServiceMapping {
      enveloppeCode
      service
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class EnveloppeProduitService {
  private _enveloppeProduitSVPs: number[];

  constructor(private queryManager: QueryManagerService) {}

  async getServiceForEnveloppe(enveloppeCode: number): Promise<BackOfficeService> {
    const result = await lastValueFrom(
      this.queryManager.query<{ enveloppeServiceMapping: ServiceByEnveloppeCode[] }>({
        query: enveloppeServiceMappingQuery,
      })
    );
    const mapping = result.data.enveloppeServiceMapping.find(item => item.enveloppeCode === enveloppeCode);
    if (!mapping) throw new Error(`Service introuvable pour l'enveloppe ${enveloppeCode}`);
    return mapping.service;
  }

  async getEnveloppes(where?: EnveloppeProduitFilterInput): Promise<EnveloppeProduit[]> {
    const result = await lastValueFrom(
      this.queryManager.query<{ enveloppeProduits: EnveloppeProduit[] }>({
        query: enveloppesQuery,
        variables: {
          where: where,
        },
      })
    );

    return result.data.enveloppeProduits;
  }

  async getEnveloppeSVPs(): Promise<number[]> {
    if (!this._enveloppeProduitSVPs || this._enveloppeProduitSVPs.length === 0) {
      const envResult = await lastValueFrom(
        this.queryManager.query<{ enveloppeProduits: EnveloppeProduit[] }>({
          query: enveloppesQuery,
        })
      );
      if (envResult.data?.enveloppeProduits) {
        this._enveloppeProduitSVPs = envResult.data.enveloppeProduits
          .filter(env => env.backOfficeService === BackOfficeService.Svp)
          .map(e => e.code);
      } else {
        this._enveloppeProduitSVPs = [];
      }
    }
    return this._enveloppeProduitSVPs;
  }
}
